<template>
    <div  class="hotOccupation">
        <div v-show="hotOccupationType.length>0&&!loadingData" class="waterfall px-container clearfix position-relative" >
            <div class="px-waterfall margin-right margin-left position-absolute commonBackground padding-top "
                 name="item"  v-for="(el,i) in hotOccupationType" :key="i">
                <div >
                    <img v-lazy="el.imgUrl" :key="el.imgUrl" alt=""/>
                </div>
                <div class="titles">
                    {{el.className}}
                </div>
                <li v-for="(item,index) in el.children" class="margin-medium-y text-left " :class="jobId===item.jobId?'directoryActive':''" @click="selectJob(item.jobId)" :key="index">
                    {{item.jobName}}
                </li>
            </div>
        </div>
        <loading :show="loadingData"></loading>
        <common-target-router @clearHref="clearHref" :getLocation="getLocation"></common-target-router>

    </div>
</template>
<script>
    import {hotOccupationType} from "../../../config";
    export default {
        name: "hotOccupation",
        data(){
            return{
                hotOccupationType:[],
                loadingData:false,
                getLocation:'',
                //获取已选择的职业
                jobId:'',
                itemBoxW:0
            }
        },

        mounted(){
            var itemBox = document.querySelector('.hotOccupation');
            this.itemBoxW=1200;
            //查出热门职业类型
            this.hotOccupaionType();
        },
        methods:{
            clearHref(){
              this.getLocation='';
            },
            selectJob(val){
                this.jobId=val;
                const {href}=this.$router.resolve({path:'/hotOccupationDetail',query:{jobId:val}});
                this.getLocation=href;
            },
            /*实现瀑布流的方法*/
            activePbl(){
                /*
                  思路分析
                  1 获取到.itemBox 宽度
                  2 获取到.item 宽度
                  3 求出列数
                  4 求出间距
                  5 实现瀑布流布局的方法
                  6 滚动页面时 加载数据
                */
                // 获取到相关元素
                var itemBox = document.querySelector('.hotOccupation');
                var items = document.getElementsByName('item');

                // 1 获取到.itemBox 宽度
                var itemBoxW = Math.ceil(itemBox.offsetWidth);
                // 2 获取到.item 宽度
                var itemW = Math.ceil(items[0].offsetWidth);
                // 3 求出列数
                var column = Math.ceil(this.itemBoxW / itemW);
                // 4 求出间距
                var distence = Math.ceil((this.itemBoxW - itemW * (column-1)) / (column - 1));

                // 5 实现瀑布流布局的方法
                // 定义一个存储每列高度的容器
                var arr = [];
                // 获取数组的最小值以及索引
                function getMin(arr) {
                    var obj = {};
                    obj.minV = arr[0];
                    obj.minI = 0;
                    for (var i = 1; i < arr.length; i++) {
                        if (obj.minV > arr[i]) {
                            obj.minV = arr[i];
                            obj.minI = i;
                        }
                    }
                    return obj;
                }
                for (var i = 0; i < items.length; i++){
                    if (i < column) {
                        items[i].style.left = (itemW + distence) * i + 'px';
                        arr[i] = items[i].offsetHeight;
                    } else {
                        var minV = getMin(arr).minV;
                        var minI = getMin(arr).minI;
                        items[i].style.left = (itemW + distence) * minI + 'px';
                        items[i].style.top = minV + distence + 'px';
                        arr[minI] = minV + distence + items[i].offsetHeight;
                    }
                }
            },
          //查出热门职业的分类
          async hotOccupaionType(){
                this.loadingData=true;
              let result=await hotOccupationType();
              if(result.status){
                  this.loadingData=false;
                  this.hotOccupationType=result.data;
                  this.$nextTick(()=>{
                    this.activePbl();
                  })
              }else{
                 this.loadingData=false;
              }
          }
        }
    }
</script>

<style lang="scss" scoped>
    .hotOccupation{
        position: relative;
        height:100vh;
        width: 100%;
        .px-container {
            width:100%;
            margin: 0 auto;
        }
        .clearfix:before,
        .clearfix:after {
            content: "";
            display: block;
            clear: both;
        }
        .clearfix {
            zoom: 1;
        }

        .waterfall {
            margin:20px auto 20px auto;

            transform: translateX(2%);
        }
        .px-waterfall:hover{
            animation: commOptionHotJob .4s ease-out forwards;
        }
        .px-waterfall {
            border-radius:10px;
            text-align: center;
            height: auto;
            width: 210px;
            padding-bottom: 10px;
            &:nth-child(3n+2) {
                margin: 0 30px;
            }
            li{
                list-style: none;
                padding-left: 48px;
                padding-right: 40px;
                cursor: pointer;
                padding-top:4px ;
                padding-bottom:4px;
            }
            li:hover{
                color:#00A4EF;
                cursor: pointer;
            }
            img  {
                height:100px;
                width:100px;
            }
            .titles{
                font-size: 20px;
                font-weight: bolder;
                color: #00A4EF;
            }
        }
    }


</style>
